import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { PromptChain } from 'rio-models';
import { PromptChainsState } from './models';
import { promptChainsActions } from './prompt-chains.actions';

export const promptChainsAdapter = createEntityAdapter<PromptChain>();
export const promptChainsInitialState: PromptChainsState = promptChainsAdapter.getInitialState({
  filteredChains: [],
  loaded: false,
});

export const promptChainsReducer = createReducer(
  promptChainsInitialState,

  on(promptChainsActions.loadChainsSuccess, (state, { chains }) => promptChainsAdapter.setAll(chains, state)),

  on(promptChainsActions.deletePromptChainSuccess, (state, { chainId }) => ({
    ...promptChainsAdapter.removeOne(chainId, state),
    filteredChains: state.filteredChains.filter(chain => chain.id !== chainId),
  })),

  on(promptChainsActions.clearAllPromptChains, () => promptChainsInitialState),

  on(promptChainsActions.loadFilteredChainsSuccess, (state, { chains }) => ({
    ...state,
    filteredChains: chains,
    loaded: true,
  })),
);

export const promptChainsFeature = createFeature({
  name: 'promptChains',
  reducer: promptChainsReducer,
});
